export default __webpack_public_path__ + "static/media/Concord-Pacific.990c88af.png";